class HtmlHelper
{
    create(tag, attrs, classes, content) {
        const el = document.createElement(tag);

        if (typeof attrs !== 'undefined' && attrs !== null) {
            this.addAttributes(el, attrs || {});
        }

        if (typeof classes === 'string' && classes !== '') {
            el.className = classes;
        } else if (typeof classes === 'object' && Array.isArray(classes) && classes.length > 0) {
            el.classList.add(classes.filter(className => typeof className === 'string' && className !== ''));
        }

        if (typeof content !== 'undefined') {
            if (!Array.isArray(content)) {
                content = [content];
            }

            content.forEach(contentItem => {
                if (typeof contentItem === 'string' || typeof contentItem === 'number') {
                    contentItem = document.createTextNode(contentItem);
                }

                el.appendChild(contentItem)
            });
        }

        return el;
    }
    addAttributes(el, attrs) {
        if (!attrs) {
            return;
        }

        for (const attrName in attrs) {
            if (Object.prototype.hasOwnProperty.call(attrs, attrName)) {
                el.setAttribute(attrName, attrs[attrName]);
            }
        }
    }
    addClass(el, className) {
        const classes = className.split(/\s+/);

        for (let i = 0; i < classes.length; i++) {
            el.classList.add(classes[i]);
        }
    }
    empty(el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    }
}

export default new HtmlHelper();
